import React, { useState, useEffect } from "react";
import { Waypoint } from "react-waypoint";
import { Link } from "react-scroll";
import heroVideo from "../../Image/Hero.mp4";

// Styles
import {
	Wrapper,
	ReactPlayerKoka,
	LoadHero,
	Container,
	ScrollDown,
} from "./Hero.styles";

const Hero = () => {
	const [videoState, setVideoState] = useState(false);
	const [load, setLoad] = useState(false);

	useEffect(() => {
		setLoad(true);
	}, []);

	return (
		<Waypoint
			onEnter={() => setVideoState(true)}
			onLeave={() => setVideoState(false)}
		>
			<Wrapper>
				{load && (
					<LoadHero src={require("./LogoKokaBulat.png").default} />
				)}
				<ReactPlayerKoka
					width="100%"
					height="100%"
					url={heroVideo}
					playing={videoState}
					loop={false}
					muted
					className="react-player"
					onReady={() => setLoad(false)}
				/>
				<Container>
					<Link to="brand" smooth={true} duration={400}>
						<ScrollDown></ScrollDown>
					</Link>
				</Container>
			</Wrapper>
		</Waypoint>
	);
};

export default Hero;
